import React from 'react';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import UserStorage from '../../../Common/UserStorage';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

const useStyles = (theme) => ({
  optionContainer: {
    //minHeight: 120,
    height: 32,
    display: 'flex'
  },
  label: {
    fontSize: '14px'
  }
});

class ButtonFilterMyFavorites extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // State from parent
      selected: this.props.selected ? this.props.selected : false,
      // Internal State
      // Menu
      openMenu: false,
      anchorEl: null
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.setState({
        selected: this.props.selected
      });
    }
  }

  handleCheckUncheck = () => {
    const newValue = this.state.selected === true ? false : true;

    this.setState(
      {
        selected: newValue
      },
      () => {
        if (this.props.handlerUpdate) {
          this.props.handlerUpdate(this.state.selected, 'USER');
        }
      }
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <div className={classes.optionContainer}>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.selected}
                onChange={this.handleCheckUncheck}
                name="filterMine"
                color="primary"
              />
            }
            label={
              <Typography className={classes.label}>
                <FormattedMessage
                  id="ButtonFilterMyFavorites.filter_myFavorites"
                  defaultMessage="My Favorites"
                />
              </Typography>
            }
          />
        </div>
      </>
    );
  }
}

export default injectIntl(withStyles(useStyles)(ButtonFilterMyFavorites));
